<template>
  <div class="etichetta-ambientale m-top-7">
    <h2 class="title-base3" v-html="$t('common.etichettaAmbientale')" />
    <div class="content-prodotto__smaltimento">
      <div class="smaltimento-table">
        <header class="smaltimento-table__row smaltimento-table__header">
          <div class="smaltimento-table__col">
            <div class="smaltimento-table__title">
              <p class="text-xsmall is-bold" v-html="$t('common.what')" />
            </div>
          </div>
          <div class="smaltimento-table__col">
            <div class="smaltimento-table__title">
              <p class="text-xsmall is-bold" v-html="$t('common.where')" />
            </div>
          </div>
        </header>
        <div class="smaltimento-table__row">
          <div class="smaltimento-table__col smaltimento-table__col__list">
            <div v-for="(option, index) in smaltimento" :key="index">
              <ul>
                <li
                  v-for="(item, itemIndex) in getSmaltimentoContent(option)"
                  :key="itemIndex"
                  class="smaltimento-table__item"
                >
                  <div class="smaltimento-table__ico">
                    <component :is="item.icon.component" :alt="item.alt" />
                  </div>
                  <p class="smaltimento-table__text text-xsmall">
                    {{ item.text }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div class="smaltimento-table__col">
            <div class="smaltimento-table__detail">
              <p
                class="smaltimento-table__detail__text text-xsmall"
                v-html="$t('common.raccoltaPlastica')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="smaltimento-table__disclaimer">
        <p class="text-small3" v-html="$t('common.disposizioni')" />
        <p
          class="text-small3"
          v-if="typeHandle === 'vino'"
          v-html="$t('common.disposizioniInfo')"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import Icon02PEHD from '@/assets/img/ico/smaltimento/02_PE-HD.svg'
import Icon07O from '@/assets/img/ico/smaltimento/07_O.svg'
import Icon05PP from '@/assets/img/ico/smaltimento/05_PP.svg'
import Icon04PELD from '@/assets/img/ico/smaltimento/04_PE-LD.svg'
import Icon90CLDPE from '@/assets/img/ico/smaltimento/90_C-LDPE.svg'

const props = defineProps({
  smaltimento: {
    type: Array,
  },
  typeHandle: {
    type: String,
    required: true,
  },
})

const { t } = useI18n()

// Smaltimento
const smaltimentoComponents = {
  lievitiBirraGreenYeast: [
    {
      icon: { component: Icon02PEHD },
      alt: '02PEHD',
      text: t('common.contenitore'),
    },
    { icon: { component: Icon07O }, alt: 'Icon07O', text: t('common.tappo') },
  ],
  lievitiVinoFlaconiETaniche: [
    {
      icon: { component: Icon02PEHD },
      alt: '02PEHD',
      text: t('common.contenitore'),
    },
    {
      icon: { component: Icon02PEHD },
      alt: '02PEHD',
      text: t('common.tappoFlacone'),
    },
    { icon: { component: Icon07O }, alt: '07O', text: t('common.tappoTanica') },
  ],
  probiosLiquidLYeastBiostimolLiquidAger: [
    {
      icon: { component: Icon02PEHD },
      alt: '02PEHD',
      text: t('common.contenitore'),
    },
    {
      icon: { component: Icon07O },
      alt: '07O',
      text: t('common.tappoFlacone'),
    },
    {
      icon: { component: Icon02PEHD },
      alt: '02PEHD',
      text: t('common.tappoTanica'),
    },
  ],
  eximia: [
    {
      icon: { component: Icon02PEHD },
      alt: '02PEHD',
      text: t('common.contenitore'),
    },
    { icon: { component: Icon05PP }, alt: '05PP', text: t('common.tappo') },
    {
      icon: { component: Icon04PELD },
      alt: '04PELD',
      text: t('common.sottotappo'),
    },
  ],
  sacchetti: [
    {
      icon: { component: Icon90CLDPE },
      alt: '90CLDPE',
      text: t('common.sacchetto'),
    },
  ],
  lysopol: [
    {
      icon: { component: Icon02PEHD },
      alt: '02PEHD',
      text: t('common.contenitore'),
    },
    { icon: { component: Icon02PEHD }, alt: '02PEHD', text: t('common.tappo') },
  ],
}
const getSmaltimentoContent = (option) => {
  return smaltimentoComponents[option] || []
}
</script>

<script>
export default {
  name: 'EtichettaAmbientale',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
